import React, { useEffect, useState } from "react";
import GLCPMEquipmentType1 from "./GlCPMEqpType1";


function GlChiller(props) {
  // const initialState = props.location!= null ? props.location.state.name : localStorage.getItem("deviceName");
  // const initialState1 = props.location != null ? props.location.state.data : localStorage.getItem("deviceID");
  // const role_id = localStorage.getItem("roleID");
  const initialState = props.location?.state?.name || localStorage.getItem("deviceName");
  const initialState1 = props.location?.state?.data || localStorage.getItem("deviceID");
  const role_id = localStorage.getItem("roleID");

  let imageParams = [
    {backgroundColor:'grey',title: 'CW in',parameter :'CHW_In_Temp', coordinates: [221.10,486.32], unit:'℃', tooltipDirection:'right',minRange:'5',maxRange:'9',defaultValue:""},
    {backgroundColor:'grey',title: 'CW out',parameter :'CHW_Out_Temp', coordinates: [307.90,492.33], unit:'℃', tooltipDirection:'right',minRange:'10',maxRange:'14',defaultValue:""},
      ];
 

  let controlsCard = [
    {title: 'Include Chiller in CPM Mode ?',parameter: '',defaultValue:"",component: 'Switch Selector',typeOf:'controls',unit:'',type:'OnOff',label1:'OFF',label2:'ON'},
    {title: 'Chiller',parameter: 'CH_Run_SS',defaultValue:"",type:'OnOff',label1:'OFF',label2:'ON',component: 'Switch Selector',typeOf:'controls',unit:''}, 
    {title: 'Chiller Motorized Valve',parameter: 'CH_Out_Vlv_SS',defaultValue:"",component: 'Switch Selector',typeOf:'controls',unit:'',type:'OnOff',label1:'OFF',label2:'ON'},
    {title: 'Chiller Mode',parameter: 'CH_AM_SS',defaultValue:"Off",component: 'Chip',type:'status',unit:''},
    {title: 'Run Status',parameter: 'CH_Run_SS',defaultValue:"Off",component: 'Chip',type:'status',unit:''},
    {title: 'Trip Status',parameter: 'CH_Trip_SS_Alarm',defaultValue:"Normal",component: 'Chip',type:'status',unit:''},
    {title: 'Run Hours',parameter: 'rh_cumulative',defaultValue:"",component: 'Chip',type:'status',unit:''},
    {title: 'Cooling Range (CR)',parameter: 'Cooling_Range',component: 'Chip',type:'status',unit:''},
  ]

  let checkEqpAMStatusChiller = [{parameter: 'CH_AM_SS'}];

  let paramsCard = [
    {title: 'Compressor 1',parameter: 'Comp_Load_1',defaultValue:"50",component: 'Progress Bar',unit:'',type:''},
    {title: 'Compressor 2',parameter: 'Comp_Load_2',defaultValue:"50",component: 'Progress Bar',unit:'',type:''},
    {title: 'Compressor 1',parameter: 'Comp_Run_Hour_1',defaultValue:"1",component: 'Text',unit:'Hrs',type:'',label1:'',label2:''},
    {title: 'Compressor 2',parameter: 'Comp_Run_Hour_2',defaultValue:"1",component: 'Text',unit:'Hrs',type:'',label1:'',label2:''},
  ] 

  let graphsCard = [{index:'1',minRange:'0',maxRange:'20',title:'Chilled Water Supply Temperature[°C]',parameters:['CHW_Out_Temp']}, {index:'2',minRange:'0',maxRange:'20',title: 'Chilled Water Return Temperature[°C]',parameters: ['CHW_In_Temp']}, {index:'3',minRange:'-10',maxRange:'10',title:'DPT[bar]',parameters:['CH_DPT']}]

  // let graphsCard = [{index:'1',title:'Chilled Water Leaving Temperature',parameters:['CWH_ST','CWH_RT']}, {index:'2',title:'Chilled Water Entry Temperature',parameters: ['CndW_HST','CndW_HRT']}]

  return (
    <>
    <GLCPMEquipmentType1 initialState={initialState} initialState1={initialState1} role_id={role_id} device='Chiller' eqpType='NONGL_SS_AIR_COOLED_CHILLER' imageParams={imageParams} controlsCard={controlsCard} paramsCard={paramsCard} checkEqpAMStatusChiller = {checkEqpAMStatusChiller} graphsCard={graphsCard} />
     {/* <GLCPMEquipmentType1 title={sample} eqpType="AHU"/> */}
    </>
  );
}

export default GlChiller;
